<template>
  <div>
    <div :class="s.wrap">
      <div v-if="flag.loading.getReservation">
        読み込み中です...
      </div>
      <div v-else-if="reservation && demandCustomer && !flag.registedOrderResult">
        <div class="bdr-b pb-4 bdr-bold">
          <div class="d-flex align-items-center">
            <p class="fw-bold">乗車人数</p>
          </div>
          <div>
            <div v-for="type of filteredPassengerTypes(true)" :key="type.name">
              <div :class="s.passenger_type_wrap">
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{ type.label }}</div>
                  <div class="d-flex align-items-center">
                    <div :class="s.buttons">
                      <div
                        :class="[s.gray, s.mt_0]"
                        @click="handlePassenger(type.name, 'minus')"><i class="fa-solid fa-minus"/></div>
                    </div>
                    <div :class="s.dp_count">{{ passengerCount[type.name] }}</div>
                    <div :class="s.buttons">
                      <div
                        :class="[s.gray, s.mt_0]"
                        @click="handlePassenger(type.name, 'plus')"><i class="fa-solid fa-plus"/></div>
                    </div>
                  </div>
                </div>
                <div v-if="adjustedPassengerCount[type.name] && type.options?.length" :class="s.passenger_option_select">
                  <div v-for="(psg, i) in adjustedPassengerCount[type.name]" :key="i">
                    <i class="fa-solid fa-user"></i>
                    <select name="" id="" class="form-control" v-model="psg.option">
                      <option :value="null">--</option>
                      <option
                        v-for="opt in (getPsgType(type.name)?.options || [])"
                        :key="opt.name"
                        :value="opt.name">{{ opt.label }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4">
          <div class="d-flex align-items-center">
            <p class="fw-bold">確定料金</p>
            <div :class="s.buttons" class="ms-auto me-0">
              <button
                :disabled="flag.loading.getFare"
                :class="[s.blue, s.mt_0]" @click="reCalculateFare('fare')">
                <i v-if="flag.loading.getFare" class="fa-solid fa-spinner fa-spin"></i>
                <span v-if="!flag.loading.getFare">再計算</span>
              </button>
            </div>
          </div>
          <div :class="s.type">
            <input :class="s.input" type="text" v-model="priceInput" @input="onPriceInput">
            <span :class="s.unit">円</span>
          </div>
          <div class="mt-3" v-if="demandDiscounts.length">
            <div class="d-flex align-items-center">
              <p class="fw-bold">割引・チケット</p>
            </div>
            <div class="mt-1 p-2 bg-gray rounded-1" v-if="demandCustomer.demandDiscounts.length">
              <div class="d-flex justify-content-between">
                <div class="fw-bold">割引適用後運賃</div>
                <div><span class="fw-bold">{{ discountedPrice }}</span> 円</div>
              </div>
              <div class="fs-sm mt-2">※ 運賃を再計算した場合、再度「適用する」を押してください。</div>
            </div>
            <div class="d-flex mt-1 align-items-center">
              <select name="" id="" class="flex-1 form-control" v-model="discountId">
                <option :value="null">選択されていません</option>
                <option
                  v-for="discount in demandDiscounts" :key="discount.id"
                  :value="discount.id">{{ discount.label }}</option>
              </select>
              <div :class="s.buttons" class="ms-auto me-0">
                <button
                  :disabled="flag.loading.getFare"
                  :class="[s.blue, s.mt_0]" @click="updateOrderResult({ closeModal: false })">
                  <i v-if="flag.loading.getFare" class="fa-solid fa-spinner fa-spin"></i>
                  <span v-if="!flag.loading.getFare">適用する</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="paymentMethods.length" class="mt-4">
          <div class="d-flex align-items-center">
            <p class="fw-bold">支払い方法</p>
          </div>
          <div>
            <div v-for="pm in paymentMethods" :key="pm.id" class="d-flex align-items-center justify-content-between mt-2">
              <div>{{ pm.label }}</div>
              <div>
                <div class="d-flex align-items-center">
                  <div :class="s.buttons">
                    <div
                      :class="[s.gray, s.mt_0]"
                      @click="handlePMAmount(pm, 'minus')"><i class="fa-solid fa-minus"/></div>
                  </div>
                  <div :class="s.pm_amount">{{ amountPerPaymentMethods[pm.name] || 0 }}</div>
                  <div :class="s.buttons">
                    <div
                      :class="[s.gray, s.mt_0]"
                      @click="handlePMAmount(pm, 'plus')"><i class="fa-solid fa-plus"/></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4 pt-4 bdr-t bdr-bold">
          <div class="d-flex align-items-center">
            <div class="mx-auto">
              <large-btn
                :style="{
                  height: '100px',
                  width: '200px',
                }"
                :disabled="flag.loading.getFare"
                @click="updateOrderResult()">確定</large-btn>
            </div>
          </div>
        </div>
      </div>
      <div v-if="data.showThanksMessage && flag.registedOrderResult">
        <div>
          <p class="text-center fs-xl">お疲れ様でした！</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import LargeBtn from '../../parts/LargeBtn.vue';

export default {
  name: 'order-result',
  props: ['data'],
  components: {
    LargeBtn,
  },
  data() {
    return {
      flag: {
        loading: {
          getReservation: false,
          getFare: false,
        },
        registedOrderResult: false,
        openSpecifiedPassengerType: false,
      },
      reservation: null,
      demandCustomer: null,
      price: 0,
      priceInput: '',
      discountedPrice: '',
      discountId: null,
      passengerCount: {},
      adjustedPassengerCount: {},
      passengerTypes: [],
      amountPerPaymentMethods: {},
    };
  },
  created() {
    if (this.data.reservationId) {
      this.getReservation();
    } else {
      alert('処理中にエラーが発生しました。');
      this.$store.dispatch('modal/contents/hideModal', null, { root: true });
    }
  },
  computed: {
    ...mapState(['user']),
    readySubmit() {
      return Object.values(this.passengerCount).reduce((a, b) => a + b, 0) > 0;
    },
    demandDiscounts() {
      return this.reservation.demandSchedule.demandArea?.demandDiscounts || [];
    },
    formattedPassengerCount() {
      const passengerCount = Object.fromEntries(this.passengerTypes.map((type) => [type.name, 0]));
      Object.entries(this.adjustedPassengerCount).forEach(([name, arr]) => {
        arr.forEach((psg) => {
          const key = psg.option ? `${name}_${psg.option}` : name;
          passengerCount[key] = passengerCount[key] || 0;
          passengerCount[key] += 1;
        });
      });
      return passengerCount;
    },
    paymentMethods() {
      return this.reservation.demandSchedule.demandArea.office.paymentMethods;
    },
  },
  watch: {
    passengerCount: {
      handler() {
        const passengerObject = {};
        Object.entries(this.passengerCount).forEach(([name, count]) => {
          passengerObject[name] = [];
          if (this.adjustedPassengerCount[name]) passengerObject[name].push(...this.adjustedPassengerCount[name]);
          if (passengerObject[name].length > count) {
            passengerObject[name] = passengerObject[name].slice(0, count);
          } else if (passengerObject[name].length < count) {
            const diff = count - passengerObject[name].length;
            for (let i = 0; i < diff; i += 1) {
              passengerObject[name].push({ option: null });
            }
          }
        });
        this.adjustedPassengerCount = passengerObject;
      },
      deep: true,
    },
  },
  methods: {
    filteredPassengerTypes(isShowCustomer) {
      return this.passengerTypes
        .filter((type) => !type.isNotUsed)
        .filter((type) => (isShowCustomer ? type.isShowCustomer !== false : type.isShowCustomer === false));
    },
    getPsgType(name) {
      return this.passengerTypes.find((type) => type.name === name);
    },
    handlePassenger(name, handleType) {
      if (handleType === 'minus' && this.passengerCount[name] === 0) {
        this.passengerCount[name] = 0;
      } else if (handleType === 'minus') {
        this.passengerCount[name] -= 1;
      } else {
        this.passengerCount[name] += 1;
      }
    },
    // 支払い方法ごとの価格の操作
    handlePMAmount(pm, handleType) {
      // 支払い方法がない || 支払い方法に選択肢がない 場合(想定外)
      if (this.paymentMethods.length < 2) return;

      const nowAmount = this.amountPerPaymentMethods[pm.name] || 0;
      const defaultPMName = this.paymentMethods.find((p) => p.is_default)?.name || this.paymentMethods[0]?.name;
      const linkPMName = pm.name === defaultPMName ? this.paymentMethods[1].name : defaultPMName;

      if (handleType === 'minus') {
        if (nowAmount >= pm.unit) this.amountPerPaymentMethods[pm.name] -= pm.unit;
        else this.amountPerPaymentMethods[pm.name] = 0;
      } else if (nowAmount + pm.unit > this.price) {
        this.amountPerPaymentMethods[pm.name] = this.price;
      } else {
        this.amountPerPaymentMethods[pm.name] += pm.unit;
      }

      const sum = Object.values(this.amountPerPaymentMethods).reduce((a, c) => a + c, 0);
      const diff = this.price - sum;
      this.amountPerPaymentMethods[linkPMName] += diff;
    },

    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },
    getPassengerCount(passengers) {
      const recordType = passengers.find((p) => p.record_type === 21) ? 21 : 11;
      return passengers.filter((p) => p.record_type === recordType);
    },
    getReservation() {
      this.flag.loading.getReservation = true;
      this.axios({
        method: 'GET',
        url: '/v1/reservation/get/detail',
        params: {
          id: this.data.reservationId,
        },
      })
        .then((response) => {
          const res = response.data;
          this.reservation = res.detail;
          this.setInitData();
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。再度お試しください。');
          this.flag.loading.getReservation = false;
        });
    },
    setInitData() {
      // 対象の顧客
      this.demandCustomer = this.reservation.demandCustomers.find((cus) => cus.id === this.data.demandCustomerId);

      if (!this.demandCustomer) {
        alert('顧客情報が見つかりませんでした。');
        this.flag.loading.getReservation = false;
        return;
      }

      // 実績のレコードがすでにあるか
      const orderResult = this.demandCustomer.demandOrderResult;

      // そのほかの値をセット
      this.price = orderResult ? orderResult.price : this.demandCustomer.price;
      this.priceInput = this.formatPrice(this.price);
      this.discountedPrice = orderResult ? orderResult.price_discounted : this.demandCustomer.price;
      this.discountId = this.demandCustomer.demandDiscounts?.[0]?.id || null;

      // 乗客数のセット
      this.passengerTypes = this.reservation.demandSchedule.demandArea.passenger_types;
      const passengers = this.getPassengerCount(this.demandCustomer?.demandPassengers || []);

      const defaultPsg = passengers.filter((psg) => this.passengerTypes.find((p) => p.name === psg.type));
      const hasOptionPsg = passengers.filter((psg) => !this.passengerTypes.find((p) => p.name === psg.type));

      this.passengerCount = Object.fromEntries(this.passengerTypes.map((type) => [type.name, 0]));

      const plus = (key, amount) => {
        this.passengerCount[key] = this.passengerCount[key] || 0;
        this.passengerCount[key] += amount;
      };
      // - ベースとなる人数をセット
      defaultPsg.forEach((psg) => {
        plus(psg.type, psg.count);
      });
      // - option付きの人数をセット
      hasOptionPsg.forEach((psg) => {
        const splited = psg.type.split('_');
        const parentKey = splited[0];
        plus(parentKey, psg.count);
      });
      this.$nextTick(() => {
        // 乗客のoptionをセット
        hasOptionPsg.forEach((psg) => {
          const splited = psg.type.split('_');
          const parentKey = splited[0];
          const childKey = splited[1];
          const hasOptionCount = this.adjustedPassengerCount[parentKey].filter((p) => p.option).length;
          this.adjustedPassengerCount[parentKey][hasOptionCount] = { option: childKey };
        });
      });

      // 支払い方法のセット
      if (this.demandCustomer.customerPaymentMethods.length && this.paymentMethods.length) {
        this.amountPerPaymentMethods = Object.fromEntries(this.paymentMethods.map((pm) => ([pm.name, 0])));
        this.demandCustomer.customerPaymentMethods.forEach((cpm) => {
          const pMName = this.paymentMethods.find((pm) => pm.id === cpm.payment_method_id).name;
          if (pMName) this.amountPerPaymentMethods[pMName] = cpm.amount;
        });
      } else if (this.paymentMethods.length) {
        const defaultName = this.paymentMethods.find((pm) => pm.is_default)?.name || this.paymentMethods[0].name;
        this.paymentMethods.forEach((pm) => {
          this.amountPerPaymentMethods[pm.name] = pm.name === defaultName ? this.price : 0;
        });
      }

      this.flag.loading.getReservation = false;
    },

    onPriceInput(event) {
      let value = event.target.value;

      // 1. 全角・半角の数字以外を除去
      value = value.replace(/[^0-9０-９]/g, '');

      // 2. 全角数字を半角数字に変換
      value = value.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0));

      const numericValue = parseInt(value, 10);
      this.price = isNaN(numericValue) ? 0 : numericValue;
      this.priceInput = this.formatPrice(this.price);
    },

    /** 数値をカンマ区切りの文字列に変換 */
    formatPrice(value) {
      return value.toLocaleString('ja-JP');
    },
    hideModal(actionType) {
      const payload = {
        type: actionType.type,
        data: {},
      };
      if (actionType.type === 'update') {
        payload.data = {
          type: 'orderResultUpdate',
          order: { id: this.data.orderId },
        };
      }
      this.$store.dispatch('modal/contents/hideModal', payload, { root: true });
      this.hideLoading();
    },
    reCalculateFare(type) {
      const fareParams = {
        demand_area_id: this.reservation.demandSchedule.demandArea.id,
        p_lat: this.demandCustomer.p_lat,
        p_lng: this.demandCustomer.p_lng,
        p_landmark_id: this.demandCustomer.p_landmark_id,
        d_lat: this.demandCustomer.d_lat,
        d_lng: this.demandCustomer.d_lng,
        d_landmark_id: this.demandCustomer.d_landmark_id,
        passenger_count: this.formattedPassengerCount,
        demand_customer_id: this.demandCustomer.id,
      };

      this.flag.loading.getFare = true;
      this.axios({
        method: 'POST',
        url: '/v1/demand/get/fare',
        data: fareParams,
      })
        .then((response) => {
          const res = response.data;
          if (type === 'fare') {
            this.price = res.details.fare || 0;
            this.priceInput = this.formatPrice(this.price);
            // 支払い方法の内訳をリセット
            if (this.paymentMethods.length) {
              this.amountPerPaymentMethods = {};
              const defaultName = this.paymentMethods.find((pm) => pm.is_default)?.name || this.paymentMethods[0].name;
              this.paymentMethods.forEach((pm) => {
                this.amountPerPaymentMethods[pm.name] = pm.name === defaultName ? this.price : 0;
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。再度お試しください。');
        })
        .finally(() => {
          this.flag.loading.getFare = false;
        });
    },
    completedOrderResult() {
      this.hideLoading();
      if (this.data.showThanksMessage) {
        this.flag.registedOrderResult = true;
        // 3秒後にモーダルを閉じる
        setTimeout(() => {
          this.hideModal({ type: 'update' });
        }, 3000);
      } else {
        this.hideModal({ type: 'update' });
      }
    },
    updateOrderResult(option = { closeModal: true }) {
      if (!Number.isInteger(this.price)) alert('料金は数字で入力してください');
      if (!this.readySubmit) {
        alert('乗車人数と料金を入力してください');
        return;
      }
      this.showLoading();
      const id = this.demandCustomer.demandOrderResult?.id;

      const data = {
        price: this.price,
        passenger_count: this.formattedPassengerCount,
        demand_customer_id: this.demandCustomer.id,
        demand_discount_id: this.discountId, // 削除の場合は明示的にnullを渡す
      };

      if (this.reservation.demandSchedule.drivers.length) {
        data.driver_id = this.reservation.demandSchedule.drivers[0].id;
      }

      if (this.paymentMethods.length) {
        data.customer_paymentMethods = [];
        Object.entries(this.amountPerPaymentMethods).forEach(([name, amount]) => {
          const pmId = this.paymentMethods.find((pm) => pm.name === name)?.id;
          if (pmId) {
            data.customer_paymentMethods.push({
              foreign_type: 11,
              foreign_id: this.demandCustomer.id,
              payment_method_id: pmId,
              amount,
            });
          }
        });
      }

      let endpoint = 'create';
      if (id) {
        endpoint = 'update';
        data.id = id;
      }

      this.axios({
        method: 'POST',
        url: `/v1/demandOrderResult/${endpoint}`,
        data,
      })
        .then((response) => {
          const res = response.data;

          if (!option.closeModal) {
            this.getReservation();
            this.hideLoading();
            return;
          }

          if (res.updated || res.demandOrderResultId) {
            this.completedOrderResult();
          } else {
            alert('エラーが発生しました。再度お試しください。');
            this.hideLoading();
          }
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。再度お試しください。');
          this.hideLoading();
        });
    },
  },
};
</script>
<style lang="scss" module="s">
.wrap {
  padding: 10px 15px;
}
.buttons {
  height: 100%;
  text-align: center;
  > * {
    border: none;
    background-color: transparent;
    padding: 0 16px;
    margin: 8px 4px 0;
    height: 100%;
    font-weight: bold;
    border-radius: 4px;
    &.mt_0 {
      margin-top: 0;
    }
    &.blue {
      background-color: var(--primary-blue);
      color: white;
    }
    &.gray {
      background-color: var(--bs-gray);
      color: white;
    }
    &.green {
      background-color: #20C997;
      color: white;
    }
    &:disabled {
      opacity: 0.5;
    }
  }
}
.type {
  display: flex;
  align-items: baseline;
  .input {
    width: 95%;
    height: 50px;
    font-size: 24px;
    text-align: right;
    padding-right: 15px;
    margin-top: 8px;
    border: 1px solid var(--bs-gray);
    border-radius: 3px;
  }
  .select {
    width: 95%;
    height: 50px;
    font-size: 24px;
    text-align: right;
    padding: 0px 15px 0px 8px;
    margin-top: 8px;
    border: 1px solid var(--bs-gray);
    border-radius: 3px;
    &.left {
      text-align: left;
    }
  }
  .checkbox {
    width: 50px;
    height: 50px;
    font-size: 24px;
    text-align: left;
    margin-top: 8px;
  }
  .unit {
    font-size: 18px;
    font-weight: bold;
    margin-left: 10px;
  }
}
.passenger_type_wrap {
  margin-top: 8px;
  padding: 12px 16px;
  border-radius: 6px;
  background-color: var(--bg-gray);
}
.passenger_option_select {
  display: flex;
  flex-wrap: wrap;
  > * {
    position: relative;
    width: 200px;
    display: flex;
    flex-direction: column;
    margin-right: 8px;
    margin-top: 8px;
    select {
      padding-left: 52px;
    }
    i {
      position: absolute;
      top: 50%; left: 0;
      translate: 0 -50%;
      font-size: 30px;
      margin-left: 12px;
    }
  }
}
.passenger_select {
  &.specified {
    padding: 12px 16px;
    border-radius: 6px;
    background-color: var(--bg-gray);
  }
}
.dp_count {
  width: 100px;
  text-align: center;
  padding: 0 0.8rem;
  margin: 0 0.2rem;
  background-color: #ffffff;
  border-radius: 6px;
}
.pm_amount {
  width: 120px;
  text-align: center;
  padding: 0 0.8rem;
  margin: 0 0.2rem;
}
</style>
